import type { BackgroundColor } from '../../constants';
import type { MotifScheme } from '../../motif';
import type { BaseComponentProps } from '../../types';

export interface SideNavigationProps extends BaseComponentProps {
  items: Array<SideNavigationSectionProps>;
  isUrlCurrent?: (url: string) => boolean;
  motifScheme?: MotifScheme;
  /** @deprecated Use motifScheme instead. */
  backgroundColor?: BackgroundColor;
  motifSchemeMobile?: MotifScheme;
  /** @deprecated Use motifSchemeMobile instead. */
  mobileBackgroundColor?: BackgroundColor;
  /** Called when a user clicks to expand/collapse a section group. */
  onSectionClick?: (sectionTitle: string, isExpanding: boolean, sectionId?: string) => void;
}

export interface SideNavigationSectionProps extends BaseComponentProps {
  id?: string;
  title: string;
  links: Array<SideNavigationItemProps>;
}

export interface SideNavigationItemProps extends BaseComponentProps {
  title: string;
  url: string;
  inNewTab?: boolean;
}

export interface SideNavigationLinksProps extends BaseComponentProps {
  links: Array<SideNavigationItemProps>;
  isUrlCurrent?: (url: string) => boolean;
  focusSection: VoidFunction;
  isRTL: () => boolean;
}
